import {
  accountArchive,
  accountChurn,
  accountFetchData,
  accountRestore,
  contactArchive,
  contactFetchData,
  contactRestore,
  createAccount,
  createContact,
  createOrganization,
  createPipeline,
  editAccount,
  editContact,
  editOrganization,
  editPipeline,
  fetchAccountDataById,
  fetchContactDataById,
  fetchOrganizationDataById,
  fetchPipelineDataById,
  organizationArchive,
  organizationChurn,
  organizationFetchData,
  organizationRestore,
  pipelineArchive,
  pipelineFetchData,
  pipelineRestore,
} from '../../store/routines';
import { instancePartialListSelector } from '../../store/selectors/customObjectSelector';
import accountSelector, {
  accountsStatsSelector,
  listPageDataSelector as accountListPageDataSelector,
} from '../../store/selectors/entities/accountSelector';
import contactSelector, {
  contactStatsSelector,
  listPageDataSelector as contactListPageDataSelector,
} from '../../store/selectors/entities/contactSelector';
import organizationSelector, {
  listPageDataSelector as organizationListPageDataSelector,
  organizationsStatsSelector,
} from '../../store/selectors/entities/organizationSelector';
import {
  pipelineSelector,
  pipelineStatsSelector,
  listPageDataSelector as pipelineListPageDataSelector,
  pipelinesPartialListSelector,
} from '../../store/selectors/entities/pipelineSelector';
import constants from './CommonConstants';
import {
  ACCOUNT_360,
  CONTACT_360,
  ORGANIZATION_360,
  PIPELINE_360,
} from './EntityScopeConstants';

export const fetchMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationFetchData,
  [constants.ACCOUNT_LEVEL]: accountFetchData,
  [constants.CONTACT_LEVEL]: contactFetchData,
  [constants.PIPELINE_LEVEL]: pipelineFetchData,
};

export const fetchByIdMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: fetchOrganizationDataById,
  [constants.ACCOUNT_LEVEL]: fetchAccountDataById,
  [constants.CONTACT_LEVEL]: fetchContactDataById,
  [constants.PIPELINE_LEVEL]: fetchPipelineDataById,
};

export const createMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: createOrganization,
  [constants.ACCOUNT_LEVEL]: createAccount,
  [constants.CONTACT_LEVEL]: createContact,
  [constants.PIPELINE_LEVEL]: createPipeline,
};

export const editMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: editOrganization,
  [constants.ACCOUNT_LEVEL]: editAccount,
  [constants.CONTACT_LEVEL]: editContact,
  [constants.PIPELINE_LEVEL]: editPipeline,
};

export const archiveMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationArchive,
  [constants.ACCOUNT_LEVEL]: accountArchive,
  [constants.CONTACT_LEVEL]: contactArchive,
  [constants.PIPELINE_LEVEL]: pipelineArchive,
};

export const restoreMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationRestore,
  [constants.ACCOUNT_LEVEL]: accountRestore,
  [constants.CONTACT_LEVEL]: contactRestore,
  [constants.PIPELINE_LEVEL]: pipelineRestore,
};

export const churnMethodMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationChurn,
  [constants.ACCOUNT_LEVEL]: accountChurn,
};

export const entitySelectorMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationSelector,
  [constants.ACCOUNT_LEVEL]: accountSelector,
  [constants.CONTACT_LEVEL]: contactSelector,
  [constants.PIPELINE_LEVEL]: pipelineSelector,
};

export const entityPartialSelectorMapping = {
  [constants.PIPELINE_LEVEL]: pipelinesPartialListSelector,
  [constants.CUSTOM_OBJECT_LEVEL]: instancePartialListSelector,
};
export const entityPageDataSelectorMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationListPageDataSelector,
  [constants.ACCOUNT_LEVEL]: accountListPageDataSelector,
  [constants.CONTACT_LEVEL]: contactListPageDataSelector,
  [constants.PIPELINE_LEVEL]: pipelineListPageDataSelector,
};
export const entityStatbarSelectorMapping = {
  [constants.ORGANIZATION_LEVEL]: organizationsStatsSelector,
  [constants.ACCOUNT_LEVEL]: accountsStatsSelector,
  [constants.CONTACT_LEVEL]: contactStatsSelector,
  [constants.PIPELINE_LEVEL]: pipelineStatsSelector,
};

export const fetchMethodByScope = {
  [ORGANIZATION_360]: fetchOrganizationDataById,
  [ACCOUNT_360]: fetchAccountDataById,
  [CONTACT_360]: fetchContactDataById,
  [PIPELINE_360]: fetchPipelineDataById,
};

export const EMAIL_TASK_ACTIONS = {
  FOLLOW_UP: 'Follow Up on',
};
